import { DesignationEnum } from '../models/common.model';

export const NO_WAREHOUSES_ALERT_MSG = 'No warehouses added yet...';

export const ERROR_MESSAGES = {
  400: 'Invalid data submitted. Please review your entries and try again.',
  401: 'You are not authorized. Please log in again.',
  403: 'You do not have permission to perform this action.',
  404: 'Requested resource not found.',
  500: 'A server error occurred. Please try again later.',
  DEFAULT: 'An unexpected error occurred. Please try again later.',
};

export const NO_TRANSPORTERS_ALERT_MSG =
  'No transporters found. You can add a new transporter by clicking on "Add Transporter".';

export const NO_ORDERS_ALERT_MSG = 'No orders found.';

export const NO_SHIPMENTS_ALERT_MSG = 'No shipments found.';

export const NO_ORDER_DETAILS_FOUND_ALERT_MSG = 'No order detailed.';

export const NO_SHIPMENT_DETAILS_FOUND_ALERT_MSG = 'No shipment details found.';

export const SALES_TEAM_DESIGNATIONS = [
  DesignationEnum.TERRITORY_SALES_MANAGER,
  DesignationEnum.AREA_SALES_MANAGER,
  DesignationEnum.SALES_OFFICER,
  DesignationEnum.REGIONAL_SALES_MANAGER,
];
